import { postApi, } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
class CustomerFeedBackReportStore {
  loading = false;
  total = 0;
  customerFeedbackData = [];
  tripData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,
      total: observable,
      customerFeedbackData: observable,
      tripData: observable,

      loadData: action,

      exportExcel: action,
      exportpdf: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      driverId: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };

    var response = await postApi.getClient("report").post("/booking_report/customerFeedbackReport", postData);

    this.customerFeedbackData = response?.data?.data?.CustomerFeedbackReport;

    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
  }

  async exportExcel(getDta) {

    try {
      await postApi.getClient("report").post("/booking_report/customerFeedbackReport/download/excel", getDta, {
        responseType: "blob",
      });
      this.pythonReportMessage = true;
    } catch (error) {
      this.pythonReportErrorMessage = true;
      message.error("Failed to download the report. Please try again.");
    }
  }

  async exportpdf(getDta) {
    try {
      await postApi.getClient("report").post("/booking_report/customerFeedbackReport/download/pdf", getDta, {
        responseType: "blob",
      });
      this.pythonReportMessage = true;

    } catch (error) {
      this.pythonReportErrorMessage = true;
      message.error("Failed to download the report. Please try again.");
    }
  }
}

export default CustomerFeedBackReportStore;
